import React from 'react';
import Header from '../../../../components/layout/headers/Header'
import Sidebar from '../../../../components/layout/navigation/sidebar/DynamicSidebar';
import PaymentsReportTable from './PaymentsReportTable'

const PaymentsReport = () => {
    return (
        <>
            <Header/>
            <Sidebar/>
            <div className="content-body">
                <div className="w-full px-4">
                    <PaymentsReportTable/>
                </div>
            </div>
        </>
    );
}

export default PaymentsReport;